export default __webpack_public_path__ + "static/media/acceptor-left.f37bcb1a.svg";